function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 21">
      <path d="M0 15 9 5l9 10h-6v6H6v-6H0ZM0 0h18v3H0V0Z" fill="currentColor" />
    </svg>
  );
}

export default Icon;
